import { Avatar, Box, Flex, Image, Text } from "@chakra-ui/react";
import { COMMON_WEB_PATH } from "../../../../constant";
import { formatNumber } from "../../../../utils/formatNumber";
import ToggleFavorite from "../../../Favorite/toggleFavorite";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import useCheckLogin from "../../../../hook/useCheckLogin";
import { useTranslation } from "react-i18next";
import { notice } from "../../../../redux/action/action";
import useCurrencySymbol from "../../../../hook/useCurrencySymbol";
import useDeviceType from "../../../../hook/useDeviceType";
import { thisImageNeedDark } from "../../../../utils/thisImageNeedDark";

const RankingCard = ({
  props,
  reverse = false,
  showPlatformAvatar = false,
}) => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common:${key}`);

  const { platform, game_code, memId, profit, game_uid } = props || {};

  const symbol = useCurrencySymbol();

  const { isLogin } = useCheckLogin();

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const isMobile = useDeviceType() === "Mobile";

  const handleEnterGame = async (gameItemProps) => {
    const { platform, game_name_en, game_uid } = gameItemProps || {};
    if (!isLogin) {
      dispatch(
        notice({
          title: i18n_common("Please login first"),
          type: "error",
        })
      );
      navigate("signin");
      return;
    }

    if (isMobile) {
      navigate(`game-confirm/${game_name_en}/${platform}/${game_uid}`);
    } else {
      navigate(`/gamebox/${game_name_en}/${platform}/${game_uid}`);
    }
  };

  return (
    <Flex
      w="100%"
      justifyContent={`space-between`}
      alignItems={`center`}
      direction={reverse ? "row-reverse" : ""}
    >
      <Box>
        <Flex
          gap="5px"
          alignItems={`center`}
          direction={reverse ? "row-reverse" : ""}
        >
          <Box mr={showPlatformAvatar ? "35px" : ""} position="relative">
            <Image
              w="45px"
              h="45px"
              borderRadius={`full`}
              src={`${COMMON_WEB_PATH}/game-icon-v2/en/${platform}/${game_code}.webp`}
            />
            {showPlatformAvatar ? (
              <Box
                name=""
                position="absolute"
                right="-35px"
                top="0px"
                w="45px"
                h="45px"
                borderRadius={`full`}
                display="flex"
                alignItems={`center`}
                justifyContent={`center`}
                border="1px solid"
                borderColor="brand.500"
                bg="leaderBoard.avatar"
                p="3px"
                overflow="hidden"
              >
                <Image
                  objectFit={`cover`}
                  width={`80%`}
                  src={`${COMMON_WEB_PATH}/platformIcon/${thisImageNeedDark(
                    platform,
                    true
                  )}.png`}
                />
              </Box>
            ) : null}
          </Box>
          <Flex
            direction={`column`}
            alignItems={reverse ? `flex-end` : `flex-start`}
            gap="0px"
          >
            <Text fontSize="11px">{memId?.slice(0, 6) + "****"}</Text>
            <Text fontSize="13px">
              {symbol}{" "}
              {formatNumber(profit, {
                point: false,
              })}
            </Text>
          </Flex>
        </Flex>
      </Box>
      <Box>
        <Flex
          direction={`column`}
          alignItems={reverse ? `flex-start` : `flex-end`}
          gap="5px"
        >
          <Box
            bgGradient={`linear(to-b, brand.100, brand.500)`}
            borderRadius={`30px`}
            px="10px"
            py="1px"
            fontSize="10px"
            color="black"
          >
            <ToggleFavorite customGameUid={game_uid} fontSize={"10px"} />
          </Box>
          <Box
            onClick={() => {
              handleEnterGame(props);
            }}
            bg="special.gold"
            borderRadius={`30px`}
            px="10px"
            py="1px"
            fontSize="10px"
            color="black"
            cursor={"pointer"}
          >
            GO
          </Box>
        </Flex>
      </Box>
    </Flex>
  );
};

export default RankingCard;
